// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/conversion.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DateRange, Money, Pagination, PaginationMeta } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.ConversionStatus
 */
export enum ConversionStatus {
  /**
   * @generated from enum value: CONVERSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONVERSION_STATUS_HOLD = 1;
   */
  HOLD = 1,

  /**
   * @generated from enum value: CONVERSION_STATUS_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: CONVERSION_STATUS_REJECTED = 3;
   */
  REJECTED = 3,

  /**
   * @generated from enum value: CONVERSION_STATUS_REFUNDED = 4;
   */
  REFUNDED = 4,

  /**
   * TRASH is not a rejection. REJECTED means the partner looked at a real
   * order and refused it — a number the buyer can work on. TRASH means there
   * was never an order: a duplicate, a test, a junk phone number. Collapsing
   * the two made every approve rate a lie about traffic quality, so the
   * reporting split is the whole point of this status.
   *
   * @generated from enum value: CONVERSION_STATUS_TRASH = 5;
   */
  TRASH = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ConversionStatus)
proto3.util.setEnumType(ConversionStatus, "tracker.v1.ConversionStatus", [
  { no: 0, name: "CONVERSION_STATUS_UNSPECIFIED" },
  { no: 1, name: "CONVERSION_STATUS_HOLD" },
  { no: 2, name: "CONVERSION_STATUS_APPROVED" },
  { no: 3, name: "CONVERSION_STATUS_REJECTED" },
  { no: 4, name: "CONVERSION_STATUS_REFUNDED" },
  { no: 5, name: "CONVERSION_STATUS_TRASH" },
]);

/**
 * Conversion is one LOGICAL conversion — the latest state of a
 * (network, goal, txid|click|payload) dedup key, read from ClickHouse
 * `tracker.conversions_current`. Its full status history lives in the
 * append-only `tracker.conversion_events` (GetConversionTimeline).
 *
 * goal_key (WHAT converted: reg/dep/rebill/sale/...) is orthogonal to
 * status (lifecycle: HOLD/APPROVED/REJECTED/TRASH/REFUNDED). goal_category and
 * counts_as_revenue are denormalized from the workspace goal registry at
 * write time.
 *
 * @generated from message tracker.v1.Conversion
 */
export class Conversion extends Message<Conversion> {
  /**
   * @generated from field: string dedup_key = 1;
   */
  dedupKey = "";

  /**
   * @generated from field: string click_id = 2;
   */
  clickId = "";

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId = "";

  /**
   * @generated from field: string campaign_id = 4;
   */
  campaignId = "";

  /**
   * @generated from field: string offer_id = 5;
   */
  offerId = "";

  /**
   * @generated from field: string network_id = 6;
   */
  networkId = "";

  /**
   * @generated from field: string goal_key = 7;
   */
  goalKey = "";

  /**
   * @generated from field: string goal_category = 8;
   */
  goalCategory = "";

  /**
   * @generated from field: bool counts_as_revenue = 9;
   */
  countsAsRevenue = false;

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 10;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * Which mapping layer resolved the goal/status:
   * offer_override|network_map|keitaro_template|global_alias|default.
   *
   * @generated from field: string match_source = 11;
   */
  matchSource = "";

  /**
   * @generated from field: tracker.v1.Money payout = 12;
   */
  payout?: Money;

  /**
   * @generated from field: string txid = 13;
   */
  txid = "";

  /**
   * @generated from field: string raw_payload = 14;
   */
  rawPayload = "";

  /**
   * @generated from field: string ts = 15;
   */
  ts = "";

  /**
   * @generated from field: int64 attribution_window_seconds = 16;
   */
  attributionWindowSeconds = protoInt64.zero;

  /**
   * @generated from field: string reject_reason = 17;
   */
  rejectReason = "";

  /**
   * Structured fields populated from Keitaro-style postback templates.
   * sub_id_1..30 + everything else not explicitly named lands in
   * tracking_fields so we never lose a parameter.
   *
   * fbclid / gclid
   *
   * @generated from field: string external_id = 20;
   */
  externalId = "";

  /**
   * @generated from field: string creative_id = 21;
   */
  creativeId = "";

  /**
   * @generated from field: string ad_campaign_id = 22;
   */
  adCampaignId = "";

  /**
   * @generated from field: string keyword = 23;
   */
  keyword = "";

  /**
   * @generated from field: string source = 24;
   */
  source = "";

  /**
   * @generated from field: string country = 25;
   */
  country = "";

  /**
   * @generated from field: tracker.v1.Money cost = 26;
   */
  cost?: Money;

  /**
   * @generated from field: map<string, string> tracking_fields = 27;
   */
  trackingFields: { [key: string]: string } = {};

  /**
   * The payout in USD at the rate of the conversion's day — what revenue
   * counts. Empty when the currency has no rate yet: the payout is NOT in
   * revenue until fx_rates has its day (the screen says «нет курса»).
   *
   * @generated from field: string reporting_payout_usd = 28;
   */
  reportingPayoutUsd = "";

  /**
   * When the lead first arrived (RFC3339). `ts` is its latest status, so a
   * status that moved has lead_ts < ts («после холда N д»).
   *
   * @generated from field: string lead_ts = 29;
   */
  leadTs = "";

  /**
   * From the conversion's click (SearchConversions): the lander it was shown
   * and the city it came from — a conversion row carries neither itself.
   *
   * @generated from field: string lander_id = 30;
   */
  landerId = "";

  /**
   * @generated from field: string city = 31;
   */
  city = "";

  constructor(data?: PartialMessage<Conversion>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Conversion";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dedup_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "goal_category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "counts_as_revenue", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 11, name: "match_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "payout", kind: "message", T: Money },
    { no: 13, name: "txid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "raw_payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "ts", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "attribution_window_seconds", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 17, name: "reject_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "creative_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "ad_campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "keyword", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "cost", kind: "message", T: Money },
    { no: 27, name: "tracking_fields", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 28, name: "reporting_payout_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "lead_ts", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Conversion {
    return new Conversion().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Conversion {
    return new Conversion().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Conversion {
    return new Conversion().fromJsonString(jsonString, options);
  }

  static equals(a: Conversion | PlainMessage<Conversion> | undefined, b: Conversion | PlainMessage<Conversion> | undefined): boolean {
    return proto3.util.equals(Conversion, a, b);
  }
}

/**
 * @generated from message tracker.v1.SearchConversionsRequest
 */
export class SearchConversionsRequest extends Message<SearchConversionsRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: tracker.v1.DateRange range = 2;
   */
  range?: DateRange;

  /**
   * @generated from field: string campaign_id = 3;
   */
  campaignId = "";

  /**
   * @generated from field: string offer_id = 4;
   */
  offerId = "";

  /**
   * @generated from field: string network_id = 5;
   */
  networkId = "";

  /**
   * @generated from field: tracker.v1.ConversionStatus status = 6;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * @generated from field: string search = 7;
   */
  search = "";

  /**
   * @generated from field: string goal_key = 8;
   */
  goalKey = "";

  /**
   * The ad (creative id) and the lander of the conversion's click — the
   * card's «Объявление» and «Ленд» filters. A conversion matches on its own
   * creative id or on its click's.
   *
   * @generated from field: string creative_id = 9;
   */
  creativeId = "";

  /**
   * @generated from field: string lander_id = 10;
   */
  landerId = "";

  constructor(data?: PartialMessage<SearchConversionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SearchConversionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "range", kind: "message", T: DateRange },
    { no: 3, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 7, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "goal_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "creative_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchConversionsRequest {
    return new SearchConversionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchConversionsRequest {
    return new SearchConversionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchConversionsRequest {
    return new SearchConversionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchConversionsRequest | PlainMessage<SearchConversionsRequest> | undefined, b: SearchConversionsRequest | PlainMessage<SearchConversionsRequest> | undefined): boolean {
    return proto3.util.equals(SearchConversionsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SearchConversionsResponse
 */
export class SearchConversionsResponse extends Message<SearchConversionsResponse> {
  /**
   * @generated from field: repeated tracker.v1.Conversion items = 1;
   */
  items: Conversion[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  /**
   * Every status under the same filters except `status` (the screen's switch).
   *
   * @generated from field: repeated tracker.v1.ConversionStatusCount status_counts = 3;
   */
  statusCounts: ConversionStatusCount[] = [];

  /**
   * What the conversions under every filter (status included) add to
   * revenue, in USD: approved, counted as revenue, with the day's rate — the
   * table's «Итого». Decimal string.
   *
   * @generated from field: string revenue_usd = 4;
   */
  revenueUsd = "";

  constructor(data?: PartialMessage<SearchConversionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SearchConversionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Conversion, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
    { no: 3, name: "status_counts", kind: "message", T: ConversionStatusCount, repeated: true },
    { no: 4, name: "revenue_usd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchConversionsResponse {
    return new SearchConversionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchConversionsResponse {
    return new SearchConversionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchConversionsResponse {
    return new SearchConversionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchConversionsResponse | PlainMessage<SearchConversionsResponse> | undefined, b: SearchConversionsResponse | PlainMessage<SearchConversionsResponse> | undefined): boolean {
    return proto3.util.equals(SearchConversionsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ConversionStatusCount
 */
export class ConversionStatusCount extends Message<ConversionStatusCount> {
  /**
   * @generated from field: tracker.v1.ConversionStatus status = 1;
   */
  status = ConversionStatus.UNSPECIFIED;

  /**
   * @generated from field: int64 count = 2;
   */
  count = protoInt64.zero;

  constructor(data?: PartialMessage<ConversionStatusCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ConversionStatusCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ConversionStatus) },
    { no: 2, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConversionStatusCount {
    return new ConversionStatusCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConversionStatusCount {
    return new ConversionStatusCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConversionStatusCount {
    return new ConversionStatusCount().fromJsonString(jsonString, options);
  }

  static equals(a: ConversionStatusCount | PlainMessage<ConversionStatusCount> | undefined, b: ConversionStatusCount | PlainMessage<ConversionStatusCount> | undefined): boolean {
    return proto3.util.equals(ConversionStatusCount, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetConversionRequest
 */
export class GetConversionRequest extends Message<GetConversionRequest> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  /**
   * @generated from field: string dedup_key = 2;
   */
  dedupKey = "";

  constructor(data?: PartialMessage<GetConversionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetConversionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dedup_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConversionRequest {
    return new GetConversionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConversionRequest {
    return new GetConversionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConversionRequest {
    return new GetConversionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetConversionRequest | PlainMessage<GetConversionRequest> | undefined, b: GetConversionRequest | PlainMessage<GetConversionRequest> | undefined): boolean {
    return proto3.util.equals(GetConversionRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetConversionResponse
 */
export class GetConversionResponse extends Message<GetConversionResponse> {
  /**
   * @generated from field: tracker.v1.Conversion conversion = 1;
   */
  conversion?: Conversion;

  constructor(data?: PartialMessage<GetConversionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetConversionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversion", kind: "message", T: Conversion },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConversionResponse {
    return new GetConversionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConversionResponse {
    return new GetConversionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConversionResponse {
    return new GetConversionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetConversionResponse | PlainMessage<GetConversionResponse> | undefined, b: GetConversionResponse | PlainMessage<GetConversionResponse> | undefined): boolean {
    return proto3.util.equals(GetConversionResponse, a, b);
  }
}

/**
 * GetConversionTimeline returns the append-only event history of one logical
 * conversion, oldest first — every accepted postback including idempotent
 * retries and status transitions.
 *
 * @generated from message tracker.v1.GetConversionTimelineRequest
 */
export class GetConversionTimelineRequest extends Message<GetConversionTimelineRequest> {
  /**
   * @generated from field: string dedup_key = 1;
   */
  dedupKey = "";

  constructor(data?: PartialMessage<GetConversionTimelineRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetConversionTimelineRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dedup_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConversionTimelineRequest {
    return new GetConversionTimelineRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConversionTimelineRequest {
    return new GetConversionTimelineRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConversionTimelineRequest {
    return new GetConversionTimelineRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetConversionTimelineRequest | PlainMessage<GetConversionTimelineRequest> | undefined, b: GetConversionTimelineRequest | PlainMessage<GetConversionTimelineRequest> | undefined): boolean {
    return proto3.util.equals(GetConversionTimelineRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetConversionTimelineResponse
 */
export class GetConversionTimelineResponse extends Message<GetConversionTimelineResponse> {
  /**
   * @generated from field: repeated tracker.v1.Conversion events = 1;
   */
  events: Conversion[] = [];

  constructor(data?: PartialMessage<GetConversionTimelineResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetConversionTimelineResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: Conversion, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConversionTimelineResponse {
    return new GetConversionTimelineResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConversionTimelineResponse {
    return new GetConversionTimelineResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConversionTimelineResponse {
    return new GetConversionTimelineResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetConversionTimelineResponse | PlainMessage<GetConversionTimelineResponse> | undefined, b: GetConversionTimelineResponse | PlainMessage<GetConversionTimelineResponse> | undefined): boolean {
    return proto3.util.equals(GetConversionTimelineResponse, a, b);
  }
}

